import * as React from 'react';
import { withDataFetch } from '../hoc/withDataFetch';

const Pie = React.lazy(() =>
  import('react-chartjs-2').then(module => ({ default: module.Pie }))
);

export default withDataFetch(Pie);
